module.exports = require("npm:call-me-maybe@1.0.1/index.js");